
import React, { ReactNode, useCallback, useState } from "react";
import { getUrl } from "aws-amplify/storage";
import { Spinner } from "reactstrap";
import classnames from "classnames";
import PdfIcon from "@assets/pdf-icon.svg?react";
import XmlIcon from "@assets/xml-icon.svg?react";
import styles from "./style.module.scss";

type AttachmentDownloadLinkProps = {
  item: {
    label: string;
    s3Key: string;
    fileType: "pdf" | "xml";
  };
  className?: string;
  bucketName?: string;
};

const AttachmentDownloadLink = (props: AttachmentDownloadLinkProps) => {
  const { item, className, bucketName } = props

  const [loading, setLoading] = useState(false);

  const handleDownload = useCallback(async () => {
    try {
      setLoading(true);

      const { url } = await getUrl({
        path: item.s3Key,
        options: {
          bucket: bucketName,
          expiresIn: 60 * 5, // 5 mi
        },
      });

      // Abrir descarga en nueva pestaña
      window.open(url.toString(), "previewDownloadLink", "noopener,noreferrer");
    } finally {
      setLoading(false);
    }
  }, [item.label, item.s3Key]);

  const getFileIcon = ({ fileType }: { fileType: "pdf" | "xml" }): ReactNode => {
    if (fileType == "pdf")
      return (<PdfIcon className={styles.icon} width={35} height={35} />);
    if (fileType == "xml")
      return (<XmlIcon className={styles.icon} width={35} height={35} />);
  }

  return (
    <button
      type="button"
      className={className}
      onClick={handleDownload}
      disabled={loading}
      style={{
        background: "transparent",
        border: "none",
        padding: 0,
        cursor: loading ? "default" : "pointer",
        textDecoration: "underline",
      }}
    >
      {getFileIcon(item)}
      {loading ? <Spinner
        className={classnames({
          "position-relative": true,
          "button-style": false,
          visible: loading,
          invisible: !loading
        })}
        size="sm"
      // type="grow"
      /> : (<b>{item.label}</b>)}
    </button>
  );
}

export default AttachmentDownloadLink;